import type {
    MembershipSpend,
    MembershipSpendUpsertDto,
} from '@fruitful/member-profile/src/spend/types/Spend';

import type { MembershipDetails } from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipSpend = requestBuilder.mutation<
    MembershipSpend,
    MembershipSpendUpsertDto,
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/membership-spend/${membershipId}`,
    method: 'POST',
});

export const useUpsertMembershipSpendAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);

    const { mutateAsync } = useUpsertMembershipSpend(
        refetchMembershipMutationOptions,
    );

    const upsertMembershipSpendAsync = async (
        membershipId: string,
        body: MembershipSpendUpsertDto,
    ) => {
        return await mutateAsync({
            urlParams: {
                membershipId,
            },
            body,
        });
    };

    return {
        upsertMembershipSpendAsync,
    };
};

export default useUpsertMembershipSpendAndRefetch;
